import instance from '../xhrService';
import db from '../../db/db';
import { random } from 'lodash';

/**
 * Commentables
 */

const url = (a, b = '', c) => `/api/notes/${a}/${b}` + (c ? `/${c}` : '');

const createOfflineCommentable = async (
  modelType,
  modelId,
  data,
  online,
  id,
) => {
  const user = await db.user.get(1);

   if(!user) {
    return 
  }

  const inspection = await db.inspections.get(Number(modelId)).catch((e) => {
    console.log('error', e);
  });

  if (!inspection) {
    return;
  }

  // Create commentable objects if comments exist
  const commentableObj = data.note
    ? {
        author: {
          name: user.name,
          id: user.user_id,
          first_name: user.first_name,
          last_name: user.last_name,
        },
        note: data.note,
        id: id && id !== 0 ? id : random(false, 1000000),
        created_at: new Date().toISOString(),
      }
    : {};

  const notes = await db.inspectionNotes.get(Number(modelId)).catch((e) => {
    console('log', e);
    throw e;
  });

  if (!notes) {
    await db.inspectionNotes.add({
      inspection_id: Number(modelId),
      notes: [commentableObj],
      sync: {
        synced: online ? true : false,
        payload: [
          {
            method: 'create',
            ...commentableObj.note,
          },
        ],
      },
    });
  } else {
    await db.inspectionNotes.update(Number(modelId), {
      notes: [...notes.notes, commentableObj],
      sync: {
        synced: online ? true : false,
        payload: [
          ...notes.sync?.payload,
          {
            method: 'create',
            ...commentableObj.note,
            id: commentableObj.id,
          },
        ],
      },
    });
  }

  return commentableObj;
};

const updateOfflineCommentable = async (
  modelType,
  modelId,
  data,
  inspectionId,
  online,
) => {
  const user = await db.user.get(1);

   if(!user) {
    return 
  }

  const inspection = await db.inspections
    .get(Number(inspectionId))
    .catch((e) => {
      console.log('error', e);
    });

  if (!inspection) {
    return;
  }

  // Create commentable objects if comments exist
  const commentableObj = data.content
    ? {
        author: {
          name: user.name,
          id: user.user_id,
          first_name: user.first_name,
          last_name: user.last_name,
        },
        note: { content: data.content },
        id: data.id,
        created_at: new Date().toISOString(),
      }
    : {};

  const notes = await db.inspectionNotes
    .get(Number(inspectionId))
    .catch((e) => {
      console('log', e);
    });

  if (notes) {
    const updatedNotes = notes.notes.map((note) => {
      if (note.id === data.id) {
        return {
          ...note,
          note: {
            ...note.note,
            content: data.content,
          },
        };
      }

      return note;
    });

    await db.inspectionNotes.update(Number(inspectionId), {
      notes: updatedNotes,
      sync: {
        synced: online ? true : false,
        payload: [
          ...notes.sync?.payload,
          {
            method: 'update',
            ...data,
          },
        ],
      },
    });

    return commentableObj;
  }

  return commentableObj;
};

const commentableApi = {
  /**
   * Index commentables on the specified morphable model
   *
   * @param {string} modelType commentable_type
   * @param {number} modelId commentable_id
   */
  index: async (modelType, modelId) => {
    if (navigator.onLine) {
      return instance.get(url(modelType, modelId)).then((_) => _.data);
    } else {
      if (modelType === 'inspections') {
        const data = await db.inspectionNotes
          .get(Number(modelId))
          .catch((e) => {
            console.log('error', e);
            throw e;
          });

        return data.notes;
      } else {
        return Promise.reject(
          new Error('Unsupported model type offline error'),
        );
      }
    }
  },
  create: async (modelType, modelId, data) => {
    if (navigator.onLine) {
      const result = await instance
        .post(url(modelType, modelId), data)
        .then((_) => _.data);

      if (modelType === 'inspections') {
        await createOfflineCommentable(
          modelType,
          modelId,
          data,
          true,
          result.id,
        );
      }

      return result;
    } else {
      if (modelType === 'inspections') {
        return createOfflineCommentable(modelType, modelId, data);
      } else {
        return Promise.reject(
          new Error('Unsupported model type offline error'),
        );
      }
    }
  },
  update: async (modelType, modelId, data, inspectionId) => {
    if (!data.id) {
      return Promise.reject(new Error('`data.id` is required'));
    }

    if (navigator.onLine) {
      const result = await instance
        .put(url(modelType, data.id), data)
        .then((_) => _.data);

      if (modelType === 'inspections') {
        await updateOfflineCommentable(
          modelType,
          modelId,
          data,
          inspectionId,
          true,
        );
      }

      return result;
    } else {
      if (modelType === 'inspections') {
        return updateOfflineCommentable(
          modelType,
          modelId,
          data,
          inspectionId,
          false,
        );
      } else {
        return Promise.reject(
          new Error('Unsupported model type offline error'),
        );
      }
    }
  },
  destroy: (id, modelType, modelId) => {
    if (navigator.onLine) {
      return instance.delete(url(modelType, id)).then(() => true);
    } else {
      if (modelType === 'inspections') {
        return db.inspectionNotes
          .update(Number(modelId), {
            notes: db.inspectionNotes.notes.filter((note) => note.id !== id),
          })
          .then(() => true)
          .catch((e) => {
            console.log('error', e);
            throw e;
          });
      } else {
        return Promise.reject(
          new Error('Unsupported model type offline error'),
        );
      }
    }
  },
};

export default commentableApi;
